module.exports = __webpack_public_path__ + "img/FERCAM_ICONE_DIVISIONALI_RGB-11.c8c26d5f.png";